import React from 'react'
import { useTranslation } from 'react-i18next'
import photo from '../../../media/img/service/primer-plano-de-hombre-de-negocios-con-tableta-digital.jpg'
import './servicesInfoHeader.scss'

const ServicesInfoHeader = () => {
    const { t } = useTranslation();

    return (
        <div className="services-info-header">
            <div className="services-info-header__img-container">
                <div className="services-triangle-left"></div>
                <img className="services-info-header__img" src={photo} alt={t('services.header.title')} />
                <div className="services-triangle-right"></div>
            </div>

            <div className="services-info-header__content">
                <div className="services-info-header__title">
                    <h1 className="services-info-header__title-text header-title__sub-page">
                        {t('services.header.title')}
                    </h1>
                </div>
                
                <div className="services-info-header__text">
                    <p className="services-info-header__text-paragraph header-subtitle__sub-page">
                        {t('services.header.subtitle')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ServicesInfoHeader